// User State
export default function () {
  // Uses nuxt 3's useState composable to enable SSR-friendly user state.
  return useState('user', () => null) as any // TODO: Type for user object
}
